import React from 'react'
import { Link as RouterLink } from 'react-router-dom'
import { Box, Icon, Link } from '@maui/elements'

export const ViewObjectLinks = ({ path, ...props }) => {
  if (typeof path !== 'string') {
    return null
  }

  return (
    <Box display="flex" justifyContent="flex-end" {...props}>
      <Box display="flex" gap="spaceGapSmall">
        <Link
          as={RouterLink}
          to={path}
          title="View more details"
          color="colorActivePrimary"
        >
          View Full Link
        </Link>
        <Box> | </Box>
        <Link
          href={path}
          title="View more details in a new window"
          alt="View more details in a new window"
          target="_blank"
          rel="noopener noreferrer"
          color="colorActivePrimary"
          display="flex"
          alignItems="center"
        >
          <Icon name='external-link' />
        </Link>
      </Box>
    </Box>
  )
}
